import React, { Fragment } from 'react';
import { Sticky, StickyContainer } from 'react-sticky';

import CategorySelector from 'components/CategorySelector';
import MediaLgUp from 'components/Responsive/MediaLgUp';
import MediaMdDown from 'components/Responsive/MediaMdDown';
import ScrollNav from 'components/ScrollNav';
import SearchField from 'components/SearchField';
import { ICategory } from 'types/possessions';

export default function InventoryComponent(props: Props) {
  const {
    activeItem,
    categories,
    children,
    filterString,
    onFilter,
    onScrollToCategory,
  } = props;

  return (
    <Fragment>
      <MediaLgUp>
        <StickyContainer style={{ height: 'auto' }} className="row">
          <div className="nav nav--stacked nav--stacked--1-of-4 nav--stacked--roman possessions__menu">
            <Sticky>
              {({ style }) => (
                <ScrollNav
                  active={activeItem}
                  data={categories}
                  style={style}
                  gotoItem={onScrollToCategory}
                  inverse
                />
              )}
            </Sticky>
          </div>
          <div className="stack-content stack-content--3-of-4">
            <SearchField onChange={onFilter} value={filterString} />
            {children}
          </div>
        </StickyContainer>
      </MediaLgUp>

      <MediaMdDown>
        <SearchField onChange={onFilter} value={filterString} />
        <div style={{ position: 'sticky', top: 0, zIndex: 1 }}>
          <CategorySelector
            data={categories.map((c, i) => ({ ...c, id: i }))}
            gotoItem={onScrollToCategory}
          />
        </div>
        {children}
      </MediaMdDown>
    </Fragment>
  );
}

interface Props {
  activeItem?: string,
  categories: ICategory[],
  children: React.ReactNode,
  filterString: string,
  onFilter: (_?: any) => void,
  onScrollToCategory: (_: any) => void,
}
